// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentGetBestEnrollmentsV2DefaultResponse {
    static getAttributeTypeMap() {
        return EnrollmentGetBestEnrollmentsV2DefaultResponse.attributeTypeMap;
    }
}
EnrollmentGetBestEnrollmentsV2DefaultResponse.discriminator = undefined;
EnrollmentGetBestEnrollmentsV2DefaultResponse.additionalProperties = false;
EnrollmentGetBestEnrollmentsV2DefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=enrollmentGetBestEnrollmentsV2DefaultResponse.js.map